import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/data";

export default function FAQ() {
  return (
    <section
      data-testid="faq-section"
      className="relative bg-ink-900 py-24 md:py-32 border-t border-ink-600"
    >
      <div className="max-w-5xl mx-auto px-4 md:px-8">
        <div className="mb-12">
          <p className="tag-kicker">Frequently asked</p>
          <h2 className="font-display text-4xl md:text-5xl font-bold leading-[1.15] tracking-normal mt-3">
            Answers before you apply.
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="border-b border-ink-600"
            >
              <AccordionTrigger className="text-left font-display text-lg md:text-xl font-medium text-white hover:text-amber hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/70 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
